import React, { useEffect, useRef, useState } from "react";
import { Music, Pause, Volume2 } from "lucide-react";
import { useApp } from "@/context/AppContext";

function resolveUrl(url) {
  if (!url) return "";
  if (url.startsWith("/api")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}

export default function HomeMusic() {
  const { config } = useApp();
  const url = resolveUrl(config?.media?.music_url);
  const enabled = config?.media?.music_enabled;
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(() => Number(localStorage.getItem("lostdc_volume") ?? 70));

  useEffect(() => {
    if (audioRef.current) audioRef.current.volume = volume / 100;
  }, [volume]);

  useEffect(() => {
    if (!url || !enabled) return;
    const tryPlay = () => {
      if (audioRef.current) audioRef.current.volume = Number(localStorage.getItem("lostdc_volume") ?? 70) / 100;
      audioRef.current?.play().then(() => setPlaying(true)).catch(() => {});
      window.removeEventListener("pointerdown", tryPlay);
    };
    window.addEventListener("pointerdown", tryPlay);
    return () => window.removeEventListener("pointerdown", tryPlay);
  }, [url, enabled]);

  if (!url || !enabled) return null;

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.volume = volume / 100;
      a.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  const changeVolume = (e) => {
    const v = Number(e.target.value);
    setVolume(v);
    localStorage.setItem("lostdc_volume", String(v));
    if (audioRef.current) audioRef.current.volume = v / 100;
  };

  return (
    <>
      <audio ref={audioRef} src={url} loop preload="none" />
      <div data-testid="home-music-player" className="fixed bottom-6 right-6 z-40 flex items-center gap-2.5 bg-[#0b1f3a] rounded-full pl-2 pr-4 py-2 shadow-xl border border-white/10">
        <button
          onClick={toggle}
          data-testid="home-music-toggle"
          aria-label={playing ? "Pause music" : "Play music"}
          className={`w-9 h-9 rounded-full bg-[#FF9933] text-white flex items-center justify-center hover:bg-[#E6892E] transition-colors ${playing ? "animate-pulse-ring" : ""}`}
        >
          {playing ? <Pause className="w-4 h-4" /> : <Music className="w-4 h-4" />}
        </button>
        <Volume2 className="w-3.5 h-3.5 text-white/60 shrink-0" />
        <input
          type="range"
          min="0"
          max="100"
          value={volume}
          onChange={changeVolume}
          data-testid="home-music-volume"
          aria-label="Music volume"
          className="w-20 h-1 accent-[#FF9933] cursor-pointer"
        />
      </div>
    </>
  );
}
